import { createSlice } from '@reduxjs/toolkit';

export const permissonsSlice = createSlice({
    name: 'permissions',
    initialState: {
        permissions: [],
        user_permissions: [],
        permissionsApplication: [],
        permissionsTree: [],
        permissions_list: null,
        permission_list_select: null,
        permission_detail: null
    },
    reducers: {
        setPermissions: ( state,  { payload }  ) => {
            state.permissions = payload;
        },
        setUserPermissions: ( state,  { payload }  ) => {
            state.user_permissions = payload;
        },
        setPermissionsApplication: ( state,  { payload }  ) => {
            state.permissionsApplication = payload;
        },
        setPermissionsTree: ( state,  { payload }  ) => {
            state.permissionsTree = payload;
        },
        setPermissionsList: ( state, { payload } ) => {
            state.permissions_list = payload;
        },
        setPermissionListSelect: ( state, { payload } ) => {
            state.permission_list_select = payload;
        },
        setPermissionDetail: ( state, { payload } ) => {
            state.permission_detail = payload;
        },
    }  
}); 


export const { setPermissions, setUserPermissions, setPermissionsApplication, 
               setPermissionsTree, setPermissionsList,
               setPermissionListSelect, setPermissionDetail } = permissonsSlice.actions;